import { defaultResource, multipleResources } from "./resource";

import {
  GetServiceResourcesDocument,
  GetServiceResourcesQuery,
  GetServiceResourcesQueryVariables,
} from "../GeneratedGraphQL";

import { createPageInfo } from "./pageInfo";
import { defaultService } from "./service";
import { MockedResponse } from "@apollo/client/testing";

const defaultResourceRequestVariables: GetServiceResourcesQueryVariables = {
  id: defaultService._id,
};

export const defaultServiceResourcesRequest: MockedResponse<GetServiceResourcesQuery> =
  {
    request: {
      query: GetServiceResourcesDocument,
      variables: defaultResourceRequestVariables,
    },
    result: {
      data: {
        service: {
          resources: {
            edges: multipleResources.map((resource) => ({
              cursor: resource._id,
              node: resource,
            })),
            pageInfo: createPageInfo({ total: 5 }),
          },
        },
      },
    },
  };

export const defaultServiceResourceRequestSingle: MockedResponse<GetServiceResourcesQuery> =
  {
    request: {
      query: GetServiceResourcesDocument,
      variables: defaultResourceRequestVariables,
    },
    result: {
      data: {
        service: {
          resources: {
            edges: [{ cursor: defaultResource._id, node: defaultResource }],
            pageInfo: createPageInfo({ total: 1 }),
          },
        },
      },
    },
  };

export const resourcesGenericErrorResourceRequest: MockedResponse<GetServiceResourcesQuery> =
  {
    error: new Error("Something went wrong getting resources"),
    request: {
      query: GetServiceResourcesDocument,
      variables: defaultResourceRequestVariables,
    },
  };

export const noServiceRequest: MockedResponse<GetServiceResourcesQuery> = {
  request: {
    query: GetServiceResourcesDocument,
    variables: defaultResourceRequestVariables,
  },
  result: { data: { service: null } },
};

export const noServiceResourcesRequest: MockedResponse<GetServiceResourcesQuery> =
  {
    request: {
      query: GetServiceResourcesDocument,
      variables: defaultResourceRequestVariables,
    },
    result: {
      data: {
        service: {
          resources: {
            edges: [],
            pageInfo: createPageInfo({ total: 0 }),
          },
        },
      },
    },
  };

export const multiPageServiceResourcesRequests: MockedResponse<GetServiceResourcesQuery>[] =
  multipleResources.map((resource, index) => ({
    request: {
      query: GetServiceResourcesDocument,
      variables: {
        ...defaultResourceRequestVariables,
        ...(index !== 0 && { cursor: multipleResources[index - 1]._id }),
      },
    },
    result: {
      data: {
        service: {
          resources: {
            edges: [{ cursor: resource._id, node: resource }],
            /* eslint-disable sort-keys */
            pageInfo: {
              total: multipleResources.length,
              hasNextPage: index !== multipleResources.length - 1,
              hasPreviousPage: index !== 0,
              startCursor: resource._id,
              endCursor: resource._id,
            },
            /* eslint-enable sort-keys */
          },
        },
      },
    },
  }));

export const unsafeResourceDescriptionRequest: MockedResponse<GetServiceResourcesQuery> =
  {
    request: {
      query: GetServiceResourcesDocument,
      variables: defaultResourceRequestVariables,
    },
    result: {
      data: {
        service: {
          resources: {
            edges: multipleResources.map((resource) => ({
              cursor: resource._id,
              node: {
                ...resource,
                description: `<p>unsafe <a data-testid="unsafe" href="/" onmouseover="alert('mouseover');">thing</a></p>`,
              },
            })),
            pageInfo: createPageInfo({ total: 5 }),
          },
        },
      },
    },
  };
